function isDef(v) {
  return v !== undefined && v !== null;
}
export function isPromise(val) {
  return isDef(val) && typeof val.then === 'function' && typeof val.catch === 'function';
}
//# sourceMappingURL=type-check.js.map
